import { useContext, useState, useEffect } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';

import { LangOpt } from './common';
import { AppContext } from '../App';
import Util from '../shared/util';
import Tr from './tr';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  })
);

export default function LanguageSelect() {
  const classes = useStyles();
  const { locale, setLocale } = useContext(AppContext);
  const [lang, setLang] = useState(LangOpt.English);
  const tr = new Tr();
  const [tooltipEnable, setTooltipEnable] = useState(true);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleChange = (event: any) => {
    // operator + is used to convert string to number
    const lang = event.target.value;
    setLang(lang);
    setLocale(Util.langToLocale(lang));
    console.log('setLang:' + lang);
  };

  useEffect(() => {
    setLang(Util.localeToLang(locale));
  }, [locale]);

  const inputElement = (
    <Tooltip
      title={tr.changeLanguage()}
      arrow
      placement="bottom"
      open={tooltipEnable && tooltipOpen}
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
    >
      <Input disableUnderline />
    </Tooltip>
  );

  const createLang = (val: string, index: number) => {
    return (
      <MenuItem value={val} key={index}>
        {val}
      </MenuItem>
    );
  };

  const languages = Object.values(LangOpt);
  return (
    <>
      <FormControl className={classes.formControl}>
        <Select
          value={lang}
          onChange={handleChange}
          name="titlebar.selectorLanguage"
          input={inputElement}
          onOpen={() => setTooltipEnable(false)}
          onClose={() => setTooltipEnable(true)}
        >
          {languages.map((lang, index) => createLang(lang, index))}
        </Select>
      </FormControl>
    </>
  );
}
